import React, { Component } from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
import PropTypes from 'prop-types'

class LoadingPanel extends Component {

	constructor(props) {
		super(props)
	}

	render() {
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding center'>
					<div className='white-filter-fill'>
						<h4>
							<span>{ this.props.title }</span>
						</h4>
					</div>
					<div className='white-filter' style={ { padding: '20px 0 30px 0' } }>
						<LinearProgress className='white-filter' mode='indeterminate' style={ { height: '10px' } }/>
					</div>
				</div>
			</div>
		)
	}
}

LoadingPanel.propTypes = {
	title: PropTypes.string.isRequired
}

LoadingPanel.defaultProps = {
	title: ''
}

export default LoadingPanel



// WEBPACK FOOTER //
// ./src/components/loading/LoadingPanel.js